<template>
  <div >
    <div style="width:400px" :id="id"></div>
  </div>
</template>
<script>
  import {calUtil} from "../../libs/calendar";
  export default {
    props: [
      'id', //id
      'year', //年
      'month', //月
      'signList1', //格式：[{signDay:'02'}]
      'signList2', //格式：[{signDay:'02'}]
      'signList3', //格式：[{signDay:'02'}]
    ],
    data() {
      return {
      };
    },

    created(){
    },
    watch:{
      signList1(val){
        if(val){
            this.newData()
        }
      },
      signList2(val){
        if(val){
            this.newData()
        }
      },
      signList3(val){
        if(val){
            this.newData()
        }
      },
    },
    mounted(){
      this.newData()
    },
    methods: {
      newData(){
        calUtil.init(this.id, this.year, this.month, this.signList1, this.signList2, this.signList3);
      let self = this;
      $(".on,.on2,.on3").on("click",function(){

        var day = $(this).html();
        var date = self.year + "-" + self.month + "-" + day;
        self.$emit('click',date);
      });
      }
    },
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/components/signCalendar.vue